import http from '@/communication/AuthConnection'

export default async ({ commit, state }, { stockId, itemId, price }) => {
  const association = await http.post(`/v1/item-association`, { stockId, itemId, price })
  return association
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/associate-item/index.js